import { PureComponent } from "react";
import { NavLink } from "react-router-dom";

import { DesignToken } from "@livechat/design-system-react-components";

import { Badge, BadgeType } from "components/badge/Badge";
import { Icon, IconsEnum } from "components/icon";
import {
  BadgeWrapper,
  StyledChevron,
  StyledNavigationItemWrapper,
  SubNavigation,
} from "components/side-navigation/styles";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ISideNavigationItem } from "interfaces/sideNavigationItem";
import { withVar } from "themes/helpers";

export interface ISideNavigationItemProps {
  item: ISideNavigationItem;
  folded?: boolean;
  activeItemId?: string;
  onItemToggle?(e: Event, id: string): void;
  onItemClick?(id: string): void;
  onParentItemClick?(e: Event, id: string): void;
}

export class SideNavigationItem extends PureComponent<ISideNavigationItemProps> {
  // FIXME: Fix this the next time the file is edited.
  // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleItemToggle = (e: any) => this.props.onItemToggle && this.props.onItemToggle(e, this.props.item.id);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  handleParentItemClick = (e: any) => {
    if (this.props.onItemClick) {
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      this.props.onItemClick(this.props.item.id);
    }

    if (this.props.onParentItemClick) {
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      this.props.onParentItemClick(e, this.props.item.id);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleChildItemClick = () => {
    if (this.props.onItemClick) {
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      this.props.onItemClick(this.props.item.id);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { item, folded } = this.props;

    if (item.render) {
      return item.render(this.props);
    }

    if (item.disabled) {
      return (
        // @ts-expect-error TS(2322)
        <StyledNavigationItemWrapper folded={folded} hasChildren={!!item.children}>
          <span>{item.name}</span>
        </StyledNavigationItemWrapper>
      );
    }

    const parentLink = item.path || (item.children && item.children.length && item.children[0].path);
    if (!parentLink) {
      return null;
    }

    const childHasBadge = item.children && !!item.children.find(childItem => !!childItem.badge);
    const parentHasBadge = item.badge || (childHasBadge && folded);

    return (
      // @ts-expect-error TS(2322)
      <StyledNavigationItemWrapper folded={folded} hasChildren={!!item.children}>
        {item.children && (
          <StyledChevron rotated={!folded} onClick={this.handleItemToggle}>
            <Icon
              name={IconsEnum.ChevronDown}
              width="12px"
              height="8px"
              fill={withVar(DesignToken.ContentBasicPrimary)}
            />
          </StyledChevron>
        )}
        <NavLink to={parentLink} exact={item.exact} onClick={this.handleParentItemClick}>
          <span>
            {item.name}
            {item.number != null && ` (${item.number})`}
          </span>
          {parentHasBadge && (
            <BadgeWrapper padded={!!item.children}>
              <Badge type={BadgeType.LiteWarning}>!</Badge>
            </BadgeWrapper>
          )}
          {item.customBadge && !parentHasBadge ? item.customBadge : null}
        </NavLink>
        {item.children && (
          // @ts-expect-error TS(2322)
          <SubNavigation folded={folded}>
            {item.children.map(childItem => (
              <li key={childItem.id}>
                {/* @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message */}
                <NavLink to={childItem.path} exact={item.exact} onClick={this.handleChildItemClick}>
                  <span>
                    {childItem.name} {childItem.number != null && ` (${childItem.number})`}
                  </span>
                  {childItem.badge && (
                    <BadgeWrapper padded>
                      <Badge type={BadgeType.LiteWarning}>!</Badge>
                    </BadgeWrapper>
                  )}
                </NavLink>
              </li>
            ))}
          </SubNavigation>
        )}
      </StyledNavigationItemWrapper>
    );
  }
}
